import services from '../../../_services/_fetch';
export function Lista(form: any, callback: any) {
  var args = {
    IdAduana: sessionStorage.getItem("rol") ==='A'? '': sessionStorage.getItem("aduana") 

   
  };
  const ENDPOINT = '/TransportistaLista';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function seek(form: any, callback: any) {
  // const cookies = new Cookies();
  //  ;
  var args = {
    IdTransportista: form.IdTransportista, // asignacion del state general
    IdAduana: form.IdAduana ? form.IdAduana : ''
  };

  const ENDPOINT = '/TransportistaSeek';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          // callback ? callback(result):done(result);
          done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function AddEditComponent(form: any, callback: any) {
  // const cookies = new Cookies();
  debugger
  console.log(form);
  var args = {
    IdAduana: form.Aduana.IdAduana,
    IdTransportista: form.Id,
    RFC: form.RFC,
    RazonSocial: form.RazonSocial,
    SCAC: form.SCAC,
    DOT: form.DOT,
    NombreTransportista: form.Apoderado,
    DomicilioCalle: form.CalleNumero,
    DomicilioColonia: form.Colonia,
    Ciudad: form.Ciudad,
    Estado: form.Estado,
    Pais: form.Pais,
    CodigoPostal: form.CodigoPostal,
    NumTelefono: form.NumeroTelefono,
    NumFax: '',
    eMail: form.Email,
    NombRepresentante: form.Representante,
    NumEscritura: form.ActaConstitutiva,
    NumeroPermiso: form.SCT,
    Creditos: form.Creditos,
    // FActivacion: form.FActivacion,
    IdTipoTrans: form.TipoTransportista.IDTipoTrans,
    saldo: form.Creditos,
    Notas: form.Notas,
    Tramite_Ventanilla: form.TramiteVentanilla,
    Usuario: sessionStorage.getItem('usuario'),
    // IdTipoTransFact: 1,//form.IdTipoTransFact,
    TipoCliente: form.TipoTransportista.IDTipoTrans,
    Credito_pospago: form.Creditos,
    TipoCobro: form.TipoCobro.Value
  };
  
  const ENDPOINT = '/TransportistaAdd';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          callback ? callback(result) : done(result);
          // done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function Baja(form: any, callback: any) {
  // const cookies = new Cookies();
  //  ;
  var args = {
    IdTransportista: form.IdTransportista,
    Op: form.Op,
    Notas: form.Notas
  };
  const ENDPOINT = '/TransportistaBA';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          if (callback) {
            callback(result);
            done(result);
          } else {
            done(result);
          }
          // done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function Creditos( callback: any) {
  var args = {
    IdAduana: sessionStorage.getItem('aduana'),
    IdTransportista: sessionStorage.getItem('transportista')
  };
  const ENDPOINT = '/TransportistaCreditos';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          // callback ? callback(result) : done(result);
          if (callback) {
            callback(result);
            done(result);
          } else {
            done(result);
          }
          // done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function ListaTiposTransportistas(callback: any) {
  var args = {
  };
  const ENDPOINT = '/TipoTransportistaLista';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          if (callback) {
            callback(result);
            done(result);
          } else {
            done(result);
          }
          // done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function ListaTiposCobroTransportista( callback: any) {
  var args = {
  };
  const ENDPOINT = '/TipoCobroLista';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          if (callback) {
            callback(result);
            done(result);
          } else {
            done(result);
          }
          // done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
